"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
//@ts-ignore
var CssBaseline_1 = tslib_1.__importDefault(require("@mui/material/CssBaseline"));
//@ts-ignore
var styles_1 = require("@mui/material/styles");
var locale_1 = require("date-fns/locale");
var setDefaultOptions_1 = tslib_1.__importDefault(require("date-fns/setDefaultOptions"));
var createTheme_1 = tslib_1.__importDefault(require("@eduzz/houston-styles/createTheme"));
var Global_1 = tslib_1.__importDefault(require("../../Dialog/Global"));
var Root_1 = tslib_1.__importDefault(require("../../Popover/Root"));
var Container_1 = tslib_1.__importDefault(require("../../Toast/Container"));
var _generator_1 = tslib_1.__importDefault(require("./_generator"));
var reset_1 = tslib_1.__importDefault(require("./reset"));
(0, setDefaultOptions_1.default)({ locale: locale_1.ptBR });
exports.createTheme = createTheme_1.default;
var defaultTheme = (0, exports.createTheme)('eduzz');
function ThemeProvider(_a) {
    var _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b, children = _a.children, disableResetStyles = _a.disableResetStyles, disableCssBaseline = _a.disableCssBaseline, disabledFontBase = _a.disabledFontBase, disableDialogs = _a.disableDialogs, disableToast = _a.disableToast;
    var _c = tslib_1.__read(React.useState(function () { return (0, _generator_1.default)(theme); }), 1), muiTheme = _c[0];
    React.useEffect(function () {
        if (disabledFontBase) {
            return undefined;
        }
        var styleElement = document.createElement('link');
        styleElement.rel = 'stylesheet';
        styleElement.href = '//fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700';
        document.head.appendChild(styleElement);
        return function () { return styleElement.remove(); };
    }, [disabledFontBase]);
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledEngineProvider, tslib_1.__assign({ injectFirst: true }, { children: (0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, tslib_1.__assign({ theme: muiTheme }, { children: (0, jsx_runtime_1.jsxs)(Root_1.default, { children: [!disableToast && (0, jsx_runtime_1.jsx)(Container_1.default, {}), !disableDialogs && (0, jsx_runtime_1.jsx)(Global_1.default, {}), !disableCssBaseline && (0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), !disableResetStyles && (0, jsx_runtime_1.jsx)(reset_1.default, {}), children] }) })) })));
}
exports.default = React.memo(ThemeProvider);
